import React, { Component, PropTypes } from 'react'
import classNames from 'classnames'

import { isEndUser, getInitials } from '../../helpers/CustomerHelpers'

import defaultAvatar from './images/default-avatar.svg'
import styles from './style.styl'

export function getUserAvatarUrl(user = {}) {
  const { attributes, socialProfile } = user
  const attributeImageUrl = attributes
    ? (attributes.get
      ? attributes.get('avatar_url', false)
      : attributes.avatar_url)
    : false
  const socialImageUrl = socialProfile
    ? (socialProfile.get
        ? socialProfile.get('avatar', false)
        : socialProfile.avatar)
    : false
  const avatarUrl = user.avatars && user.avatars['image200'] || user.avatarUrl
  return avatarUrl || attributeImageUrl || socialImageUrl
}

export function userHasAvatar(user) {
  return !!getUserAvatarUrl(user)
}

export default class Avatar extends Component {
  static propTypes = {
    user: PropTypes.object,
    size: PropTypes.oneOf(['extra-small', 'small', 'medium', 'large', 'extra-large', 'jumbo']),
    shape: PropTypes.oneOf(['circle', 'square']),
    showInitials: PropTypes.bool,
    style: PropTypes.object,
    selected: PropTypes.bool,
  }

  static defaultProps = {
    showInitials: false,
    shape: 'square',
  }

  renderUserImage(user) {
    if (!user) {
      return null
    }
    const avatarUrl = getUserAvatarUrl(user)
    if (avatarUrl) {
      return <div className="avatar-image" style={{ backgroundImage: `url(${avatarUrl}), url(${defaultAvatar})` }}/>
    }
  }

  renderUserInitials(user) {
    const { showInitials } = this.props
    const initials = getInitials(user)
    if (showInitials && initials) {
      return (
        <div className="default">
          <div className={classNames('initials', { endUser: isEndUser(user) })}>
            {initials}
          </div>
        </div>
      )
    }
  }

  renderDefaultAvatar() {
    return <img className="default-avatar" src={defaultAvatar}/>
  }

  render() {
    const { user, shape, size, style, selected } = this.props
    const avatarImage = this.renderUserImage(user) || this.renderUserInitials(user)
    const finalClassName = classNames(
      'Avatar',
      styles[shape],
      size,
      {
        selected,
        default: !avatarImage,
      }
    )
    return (
      <div
        className={finalClassName}
        style={style}
      >
        {avatarImage || this.renderDefaultAvatar()}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./node_modules/shared-web/src/components/Avatar/index.js